import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const PageBlock = async ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      {blok.body?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </div>
  );
};

export default PageBlock;
